import Marquee from "react-fast-marquee";

const words = [
  "Quality Assurance",
  "Independent Audit",
  "Practice Improvement",
  "Inspection Readiness",
  "Post-Inspection Support",
  "Training & Development",
  "Policy Writing",
];

export function EditorialMarquee() {
  return (
    <div
      className="border-y border-ink/10 bg-cream py-10 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee speed={30} gradient={false} pauseOnHover>
        {words.map((word, i) => (
          <span key={i} className="mx-10 inline-flex items-center gap-10">
            <span className="font-display italic text-3xl sm:text-4xl text-ink whitespace-nowrap">
              {word}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-brand shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
